import { QBankStructureStatus } from '@exam-management/graphql';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { Button } from '@shared/components';

interface QBankStructureLevelFormActionProps {
  onClose: () => void;
}

export default function QBankStructureLevelFormAction(
  props: Readonly<QBankStructureLevelFormActionProps>,
) {
  const { onClose } = props;
  const { qBankStructureInformation } = useQBankStructure();

  const isEditable = qBankStructureInformation?.status === QBankStructureStatus.Draft;

  if (isEditable) {
    return (
      <>
        <Button onClick={onClose} variant='outlined' color='secondary' size='large'>
          Cancel
        </Button>
        <Button type='submit' size='large'>
          Save & Apply
        </Button>
      </>
    );
  }

  return (
    <Button onClick={onClose} variant='outlined' color='secondary' size='large'>
      Cancel
    </Button>
  );
}
